<template>
	<v-app-bar app color="accent" dark>
		<div class="d-flex align-center">
		</div>
		<v-spacer></v-spacer>
	</v-app-bar>
</template>

<script>
	export default {
		name: 'AppHeader'
	};
</script>

<style scoped>

</style>
